import { render, staticRenderFns } from "./ImageMini.vue?vue&type=template&id=2ea18ac6&scoped=true"
import script from "./ImageMini.vue?vue&type=script&lang=js"
export * from "./ImageMini.vue?vue&type=script&lang=js"
import style0 from "./ImageMini.vue?vue&type=style&index=0&id=2ea18ac6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea18ac6",
  null
  
)

export default component.exports